/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Tools_None_HintInputs */



/**
* | output |
* | --- |
* | "No tools available here." |
*
* @param {Project_References_Tools_None_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_tools_none_hint = /** @type {((inputs?: Project_References_Tools_None_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Tools_None_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hier sind keine Werkzeuge verfügbar.")
	return /** @type {LocalizedString} */ ("No tools available here.")
});